<template>
    <InertiaLink class="inline-block py-2 px-2 mt-1 hover:bg-gray-100 rounded-lg" v-if="variant !== 'destroy'">
        <template v-if="variant === 'show'">
            <EyeIcon class="h-4 w-4 text-indigo-500" />
        </template>
        <template v-if="variant === 'edit'">
            <PencilIcon class="h-4 w-4 text-indigo-500" />
        </template>
    </InertiaLink>

    <a href="#" class="inline-block py-2 px-2 mt-1 hover:bg-gray-100 rounded-lg" @click.prevent="$emit('delete')" v-else>
        <TrashIcon class="h-4 w-4 text-red-500" />
    </a>
</template>

<script>
    import { EyeIcon, TrashIcon, PencilIcon } from '@heroicons/vue/solid'

    export default {
        components: {
            EyeIcon,
            TrashIcon,
            PencilIcon,
        },
        props: {
            variant: String,
        },
    }
</script>
